import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string'

class Connect extends React.Component {

    componentDidMount() {
        const token = this.props.user_token;
        if (token) {
            localStorage.setItem('om_user_token', token);
            localStorage.removeItem('om_statuts_shippeds');
            var params = queryString.parse(this.props.location.search);
           
            /*if(params.redirect == "proche"){
                this.props.history.push('/colis/list?typeredirect='+params.redirect+'&t=' + Date.now());
                
            }else if(params.redirect == "retard"){
                this.props.history.push('/colis/list?statut_alert=reported_retard&title=Liste des colis à reporter en retard&t=' + Date.now());
              
            }else if(params.redirect && params.redirect.includes("colis") && params.redirect.includes("réclamation")){
                //alert("1");
                //alert(window.location.href);
                var number_colis = params.redirect.replace('Vous avez une nouvelle réclamation sur le colis N °','');
                var number_colis = params.redirect.replace('Vous avez une nouvelle réclamation sur le colis N°','');

                var number_colis = params.redirect.replace('vous avez une nouvelle réclamation sur le colis n °','');
                var number_colis = params.redirect.replace('vous avez une nouvelle réclamation sur le colis n°','');
                //alert(number_colis);
                this.props.history.push('/colis-message?colis='+number_colis+'&t=' + Date.now());
                
            }else if(params.redirect && params.redirect.includes("colis")){
                //alert("2");
                //alert(window.location.href);
                var number_colis = params.redirect.replace('Vous avez une nouvelle réclamation sur le colis N °','');
                var number_colis = params.redirect.replace('Vous avez une nouvelle réclamation sur le colis N°','');

                var number_colis = params.redirect.replace('vous avez une nouvelle réclamation sur le colis n °','');
                var number_colis = params.redirect.replace('vous avez une nouvelle réclamation sur le colis n°','');
                //alert(number_colis);
                this.props.history.push('/colis/list?fixedkeyword='+number_colis+'&t=' + Date.now());
                
            }else if(params.redirect == "direction"){
                this.props.history.push('/messages?t=' + Date.now());
                
            }else{
                this.props.history.push(`/colis/shipped`);
            }*/

            if(params.redirectocolisretard == "yes"){
               this.props.history.push('/colis/list?statut_alert=reported_retard&title=Liste des colis à reporter en retard&t=' + Date.now());
                
            }else if(params.redirectocolisproche == "yes"){
                this.props.history.push('/colis/list?typeredirect=proche&t=' + Date.now());
                
            }else if(params.redirectocolismessage){
               this.props.history.push('/colis-message?colis='+params.redirectocolismessage+'&t=' + Date.now());
                
            }else{
                this.props.history.push(`/colis/shipped`);
            }
        }
    }

    render() {
        return (<div></div>);
    }

}
export default withRouter(Connect);